import * as React from 'react';

const Checkbox = (props) => {
    return (
        <div className="form-group">
            {
                props.onChange == null ?
                <input className="form-check-input" id={props.name} type="checkbox" checked={props.value} style={{marginRight:"6px"}} disabled={props.disabled} />
                :
                <input className="form-check-input" id={props.name} type="checkbox" checked={props.value} onChange={e => props.onChange(e.target.checked)} style={{marginRight:"6px"}} disabled={props.disabled}/>
            }
            <input type="hidden" name={props.name} value={props.value} />
            <label htmlFor={props.name}>
                {props.label}
            </label>
        </div>
    )
}

export default Checkbox;


// WEBPACK FOOTER //
// ./components/forms/checkbox/index.jsx